import { Link } from "react-router-dom";
import { getHotMovies, typeLabel } from "@/utils/movieUtils";
import SectionHeading from "@/components/feature/SectionHeading";

export default function HotRanking() {
  const list = getHotMovies(10);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-8 md:px-8 md:py-10">
      <SectionHeading
        title="热门影视排行"
        subtitle="根据站内热度统计的人气榜单（示范数据）"
        icon="ri-fire-line"
      />
      <div className="grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-x-8">
        {list.map((movie, idx) => (
          <Link
            key={movie.id}
            to={`/detail/${movie.id}`}
            className="group flex items-center gap-4 rounded-lg border border-transparent bg-background-50 px-3 py-2.5 transition-colors hover:border-primary-200 hover:bg-primary-50/60"
          >
            <span
              className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                idx < 3
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-200 text-foreground-600"
              }`}
            >
              {idx + 1}
            </span>
            <div className="h-14 w-10 shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={movie.cover}
                alt={`${movie.title} 封面`}
                title={`${movie.title} 日本影视`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="line-clamp-1 font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
                {movie.title}
              </h3>
              <p className="mt-0.5 line-clamp-1 text-xs text-foreground-400">
                {typeLabel(movie.type)} · {movie.year} · {movie.genres.join(" / ")}
              </p>
            </div>
            <span className="flex shrink-0 items-center gap-1 text-sm font-semibold text-accent-600">
              <i className="ri-star-fill" aria-hidden="true"></i>
              {movie.rating.toFixed(1)}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}